import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Toaster } from "./components/ui/sonner";

// Layout Components
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import HomePage from "./pages/HomePage";
import ToolsListPage from "./pages/ToolsListPage";
import HirePage from "./pages/HirePage";
import BlogPage from "./pages/BlogPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import SitemapPage from "./pages/SitemapPage";
import NotFoundPage from "./pages/NotFoundPage";

// Tool Pages
import JSONFormatterPage from "./pages/tools/JSONFormatterPage";
import Base64EncoderPage from "./pages/tools/Base64EncoderPage";
import URLEncoderPage from "./pages/tools/URLEncoderPage";
import ColorPickerPage from "./pages/tools/ColorPickerPage";
import HashGeneratorPage from "./pages/tools/HashGeneratorPage";
import JWTDecoderPage from "./pages/tools/JWTDecoderPage";
import LoremIpsumPage from "./pages/tools/LoremIpsumPage";
import MarkdownPreviewPage from "./pages/tools/MarkdownPreviewPage";
import UUIDGeneratorPage from "./pages/tools/UUIDGeneratorPage";
import TimestampConverterPage from "./pages/tools/TimestampConverterPage";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              {/* Main Pages */}
              <Route path="/" element={<HomePage />} />
              <Route path="/tools" element={<ToolsListPage />} />
              <Route path="/hire" element={<HirePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/sitemap" element={<SitemapPage />} />

              {/* Tool Pages */}
              <Route path="/tools/json-formatter" element={<JSONFormatterPage />} />
              <Route path="/tools/base64-encoder" element={<Base64EncoderPage />} />
              <Route path="/tools/url-encoder" element={<URLEncoderPage />} />
              <Route path="/tools/color-picker" element={<ColorPickerPage />} />
              <Route path="/tools/hash-generator" element={<HashGeneratorPage />} />
              <Route path="/tools/jwt-decoder" element={<JWTDecoderPage />} />
              <Route path="/tools/lorem-ipsum" element={<LoremIpsumPage />} />
              <Route path="/tools/markdown-preview" element={<MarkdownPreviewPage />} />
              <Route path="/tools/uuid-generator" element={<UUIDGeneratorPage />} />
              <Route path="/tools/timestamp-converter" element={<TimestampConverterPage />} />

              {/* 404 Page */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
